var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1002 18.7576C15.9955 18.7576 13.9161 18.2989 11.8619 17.3816C9.80775 16.4643 7.93881 15.1635 6.25507 13.4791C4.57134 11.7947 3.27082 9.92572 2.35352 7.87223C1.43622 5.81875 0.977236 3.73934 0.976562 1.634C0.976562 1.33092 1.07759 1.07836 1.27963 0.876314C1.48168 0.674266 1.73424 0.573242 2.03732 0.573242H6.12879C6.36452 0.573242 6.57498 0.653388 6.76019 0.81368C6.9454 0.973971 7.05485 1.16322 7.08852 1.38144L7.74518 4.91728C7.77885 5.18668 7.77043 5.41398 7.71992 5.59919C7.66941 5.7844 7.5768 5.94436 7.44211 6.07906L4.99227 8.55415C5.32902 9.17713 5.72874 9.7789 6.19143 10.3594C6.65412 10.94 7.16362 11.5 7.71992 12.0395C8.24188 12.5614 8.78909 13.0457 9.36156 13.4922C9.93403 13.9387 10.5402 14.3469 11.18 14.7166L13.5541 12.3426C13.7056 12.191 13.9036 12.0775 14.1481 12.0021C14.3926 11.9267 14.6323 11.9055 14.8674 11.9385L18.3527 12.6456C18.5884 12.713 18.7821 12.8352 18.9336 13.0123C19.0851 13.1895 19.1609 13.3871 19.1609 13.6054V17.6968C19.1609 17.9999 19.0599 18.2525 18.8578 18.4545C18.6558 18.6566 18.4032 18.7576 18.1002 18.7576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6496010634b0c409e88d7d0e6edbd4d9.svg";
export { ForwardRef as ReactComponent };